<template>
    <v-data-table v-bind="$attrs" v-on="$listeners"
                  :id="uID"
                  class="my-data-table"
                  :height="headersHeight"
                  :items="items"
                  :fixed-header="fixedHeader"
                  :footer-props="localFooterProps"
                  :options.sync="options">
        <template v-for="(slot, name) in $scopedSlots" v-slot:[name]="item">
            <slot :name="name" v-bind="item"></slot>
        </template>
    </v-data-table>
</template>

<script>
    export default {
        props: {
            'footer-props': {
                type: Object,
                require: false,
                default: null,
            },
            items: {
                type: Array,
                require: false,
                default: undefined,
            },
            defaultHeightNum: {
                type: Number,
                require: false,
                default: 15,
            },
            fixedHeader: {
                type: Boolean,
                require: false,
                default: false,
            },
            options: {
                type: Object,
                required: false,
                default: () => ({}),
            },
        },
        computed: {
            uID() {
                return this._uid.toString();
            },
            localFooterProps() {
                if (this.footerProps === null) {
                    return {
                        'items-per-page-options': [5, 10, 15, -1],
                    };
                }
                return this.footerProps;
            },
        },
        watch: {
            items: function () {
                // アイテム数変更時
                this.headersHeight = this.flexDataTableHeight();
            },
            'items-per-page': function () {
                this.headersHeight = this.flexDataTableHeight();
            },
            'options.itemsPerPage': function () {
                // ページ当たりの件数変更時
                this.headersHeight = this.flexDataTableHeight();
            },
        },
        data: () => ({
            rowHeight: 24,
            headersHeight: '',
            options: {
                page: 1,
                itemsPerPage: 10,
            },
        }),
        methods: {
            localProps() {
                return {
                    'items-per-page-options': [10, -1],
                };
            },
            flexDataTableHeight() {
                if (!this.fixedHeader) {
                    // ヘッダ固定なし
                    return '';
                }

                let defaulNum = Number(this.defaultHeightNum) + 1;
                if (this.options.itemsPerPage === -1) {
                    // 全件表示
                    defaulNum = Number(this.defaultHeightNum) + 1;
                } else if (this.options.itemsPerPage < this.defaultHeightNum) {
                    defaulNum = this.options.itemsPerPage + 1;
                } else {
                    defaulNum = Number(this.defaultHeightNum) + 1;
                }

                const maxHeight = (this.rowHeight * defaulNum + 25).toString();
                //defalt 18
                if (this.items.length <= defaulNum) {
                    return '';
                }
                return maxHeight;
            },
        },
    };
</script>

<style>
    .my-data-table tbody tr:nth-of-type(odd) {
        background-color: rgba(0, 0, 0, .05);
    }

    .my-data-table {
        white-space: nowrap;
    }

    .my-data-table tbody td{
        height:24px;
        
    }

</style>
